export function YouTubeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#FF0000"
      />
      <path
        d="M18.1321 9.03671C17.9849 8.4712 17.5512 8.02589 17.0004 7.87476C16.0023 7.6001 11.9996 7.6001 11.9996 7.6001C11.9996 7.6001 7.99692 7.6001 6.99874 7.87476C6.44797 8.02589 6.01423 8.4712 5.86703 9.03671C5.59961 10.0616 5.59961 12.2001 5.59961 12.2001C5.59961 12.2001 5.59961 14.3385 5.86703 15.3635C6.01423 15.929 6.44797 16.3743 6.99874 16.5255C7.99692 16.8001 11.9996 16.8001 11.9996 16.8001C11.9996 16.8001 16.0023 16.8001 17.0004 16.5255C17.5512 16.3743 17.9849 15.929 18.1321 15.3635C18.3996 14.3385 18.3996 12.2001 18.3996 12.2001C18.3996 12.2001 18.3996 10.0616 18.1321 9.03671Z"
        fill="white"
      />
      <path d="M10.7998 14.3999V10.3999L13.9998 12.4L10.7998 14.3999Z" fill="#FF0000" />
    </svg>
  );
}
